module.exports = __webpack_public_path__ + "static/media/4.183a0dd6.jpg";